import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Container, Alert, Grid, Dialog, DialogContent, FormControlLabel, Checkbox, DialogActions, DialogTitle } from '@mui/material';
import DisplayForm from '../Table/DisplayForm'
import { getInfoPerRegistrationPlate} from '../../api/axios';
import { useTranslation } from 'react-i18next';

const PerRegistrationPlate = () => {
    const { t } = useTranslation('global');

    const [ticket, setTicket] = useState({});
    const {registration_plates}  = useParams();
    console.log(registration_plates);
    const navigate = useNavigate();
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const params = new URLSearchParams({ registration: registration_plates })
                const response = await getInfoPerRegistrationPlate(params);
                setTicket(response);
                console.log(response);
            } catch (error) {
                console.error(t("search.errorFetchingTicketInfo"), error);
            }
        };
        fetchData();
    }, [registration_plates]);

  return (
    <Container maxWidth="sm" style={{alignItems: "center", justifyContent:"center"}}>
            <Box sx={{ mt: 4, p: 3, borderRadius: 2, boxShadow: 3, backgroundColor: '#f9f9f9',}}>
                <Typography variant="h4" align="center" gutterBottom>
                    {t("search.ticketInfo")  + " - " + ticket.registration}
                </Typography>
                
                <form className="form">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="name"
                                label={t("edit.name")}
                                value={ticket.name ? ticket.name : ""}
                                variant="outlined"
                                slotProps={{
                                      input: {
                                        readOnly: true,
                                      },
                                    }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="lastName"
                                label={t("edit.lastName")}
                                value={ticket.surname ? ticket.surname : ""}
                                variant="outlined"
                                slotProps={{
                                      input: {
                                        readOnly: true,
                                      },
                                    }}
                            />
                        </Grid>
                        
                    </Grid>
                    <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                  fullWidth
                                  id="serial"
                                  label={t("search.serial")}
                                  value={ticket.ticket_id ? ticket.ticket_id : ''}
                                  variant="outlined"
                                  slotProps={{
                                      input: {
                                        readOnly: true,
                                      },
                                    }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                            <TextField
                                        fullWidth
                                        id="phone"
                                        label={t("edit.phoneNumber")}
                                        value={ticket.phone ? ticket.phone : ''}
                                        slotProps={{
                                            input: {
                                              readOnly: true,
                                            },
                                          }}
                                        variant="outlined"
                                    />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="create_time"
                                label={t("search.dateCreated")}
                                value={ticket.create_time ? ticket.create_time : ''}
                                variant="outlined"
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                        fullWidth
                                        id="remaining_passes"
                                        label={t("search.remainingPasses")}
                                        value={ticket.entry_no ? ticket.entry_no : ''}
                                        slotProps={{
                                            input: {
                                              readOnly: true,
                                            },
                                          }}
                                        variant="outlined"
                                    />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="remaining_days"
                                label={t("search.remainingDays")}
                                value={ticket.day_no ? ticket.day_no : ''}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="daily_passes"
                                label={t("search.remainingDailyPasses")}
                                value={ticket.daily_no  ? ticket.daily_no : ''}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="hFrom"
                                label={t("search.hFrom")}
                                value={ticket.h_from ? ticket.h_from : ''}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="hTo"
                                label={t("search.hTo")}
                                value={ticket.h_to ? ticket.h_to : ''}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                  }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                
                    <Grid container spacing={2} justifyContent={'flex-end'}>
            
                        <Grid item xs={12} sm={6}>
                            <Button
                                fullWidth
                                type="button"
                                variant="contained"
                                color="error"
                                onClick={() => { navigate('/') }}
                            >
                            {t("search.back")}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Container>
  )
}

export default PerRegistrationPlate
